import React, { Component } from 'react';
import { connect } from 'react-redux'
import MySelect from '../components/MySelect'
import { selectOptions } from '../actions/options'


class SelectColorType extends Component {
    inputProps={
        name:'colorType',
    }

    handleChangeSelect(value) {
        this.props.selectOptions( {colorTypeId:value} )
    }
    render() {
        const { defaultValue, options } = this.props;
        return (
            <MySelect
                handleChange={this.handleChangeSelect.bind(this)}
                inputProps={this.inputProps}
                options={options}
                defaultValue={defaultValue}
            />
        );
    }
}

const mapStateToProps = state => ({
    defaultValue: state.options.selected.colorTypeId,
    options: state.options.colorType,
})

const mapDispatchToProps = dispatch => ({
    selectOptions: (selected) => dispatch( selectOptions(selected) ),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectColorType);



// WEBPACK FOOTER //
// ./src/components/SelectColorType.js